import { asCalendarDateString, formatCalendarDate } from '@resida/shared';
export function formatRentCents(cents) {
    return `$${(cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })}`;
}
/** "Nov 7, 2026" from a YYYY-MM-DD calendar date (never shifted by the viewer's timezone). */
export function formatDate(dateStr) {
    return formatCalendarDate(asCalendarDateString(dateStr), {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}
/** US phone numbers as "(512) 555-0123"; anything else (international, partial) is shown as saved. */
export function formatPhoneDisplay(raw) {
    const value = raw?.trim() ?? '';
    const digits = value.replace(/\D/g, '');
    const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
    if (national.length !== 10)
        return value;
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}
//# sourceMappingURL=format.js.map